import { useState } from "react";
import { useTranslation } from "react-i18next";

import ConfirmDialog from "../dialogTypes/ConfirmDialog";

import apiClient from "../../lib/common/apiClient";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import MomSysAllShipDialogWithShipDate from "../dialogTypes/MomSysAllShipDialogWithShipDate";

function MomSysAllShipButtonWithShipDate(props) {
    const { id, onShipSelectMst, refresh, onUpdateMaster, onSuccess, onFailure, ...others } = props;
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);

    const [confirmMsg, setConfirmMsg] = useState();
    const [confirmData, setConfirmData] = useState();

    const onOpen = () => {
        setOpen(true);

        setConfirmMsg(t("dialog.msg.confirm.allShip", { orderBuyerId: onShipSelectMst.orderBuyerId }));
        setConfirmData(onShipSelectMst);
    };

    const onAllShipSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        if (onUpdateMaster) {
            onUpdateMaster();
        }

        if (refresh) {
            refresh.refresh();
        }
    };

    const onOk = (data, shipDate) => {
        let url;

        url = `/api/Material/${data.orderBuyerId}/ship/all`;

        let form = new FormData();

        let deleted = {};

        form.append("deleted", JSON.stringify(deleted));
        form.append("json", JSON.stringify({...data, shipDate}));

        apiClient
            .post(url, form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((result) => {
                onAllShipSuccess(result.data);
            })

            .catch((reason) => {
                onFailure(
                    t("error.allShip", { orderBuyerId: onShipSelectMst.orderBuyerId }) +
                        ` : ${reason.response ? reason.response.data : JSON.stringify(reason)}`
                );
            });
    };

    const onClose = () => {
        setOpen(false);
    };

    return (
        <>
            <CreateRecordButtonLayout
                id={id + "-all-ship-button"}
                onClick={onOpen}
                createButtonName={"allShip"}
                {...others}
            />
            <MomSysAllShipDialogWithShipDate
                id={id + "-all-ship-confirm-dialog"}
                title={t("dialog.title.MomSysShip.allShip")}
                open={open}
                msg={confirmMsg}
                onClose={onClose}
                onCancel={onClose}
                data={onShipSelectMst}
                onOk={onOk}
            />
        </>
    );
}

export default MomSysAllShipButtonWithShipDate;
